/**
 * Scroll utility functions for TaskComments component
 */

/**
 * Check if scrollable container is near bottom
 * @param container - The scrollable HTML element
 * @param threshold - Distance from bottom in pixels (default: 100)
 * @returns true if container is within threshold pixels from bottom
 */
export const isNearBottom = (
  container: HTMLDivElement,
  threshold: number
): boolean => {
  const { scrollTop, scrollHeight, clientHeight } = container;
  return scrollHeight - scrollTop - clientHeight < threshold;
};
